import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { patchPropertyInsuranceFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchPropertyInsurance/patchPropertyInsuranceFunction';
import { PatchPropertyInsuranceType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchPropertyInsurance/patchPropertyInsurance.type';

export const patchPropertyInsuranceOptions = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  PatchPropertyInsuranceType
> => ({
  mutationKey: ['patch-damaged-insurance-property'],
  mutationFn: ({ id, formData, damaged_id }: PatchPropertyInsuranceType) =>
    patchPropertyInsuranceFunction({ id, formData, damaged_id }),
});
